module.exports = __webpack_public_path__ + "img/add.f7f93a7d.svg";